import { render, staticRenderFns } from "./cenCollect.vue?vue&type=template&id=1c49b348&scoped=true&"
import script from "./cenCollect.vue?vue&type=script&lang=js&"
export * from "./cenCollect.vue?vue&type=script&lang=js&"
import style0 from "./cenCollect.vue?vue&type=style&index=0&id=1c49b348&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c49b348",
  null
  
)

export default component.exports